export const screenName = 'home';
